import { noneProfile } from "assets";
import DatePicker from "components/app/function/DatePicker";
import NumberInput from "components/app/function/NumberInput";

import TimePicker from "components/app/function/TimePicker";
import ImageUrl from "components/app/image-url/ImageUrl";
import { ScrollArea, ScrollBar } from "components/ui/scroll-area";
import { CircleAlert, Loader, Minus, Plus, X } from "lucide-react";
import { useEffect, useState } from "react";
import { Service } from "utils/services";
import moment from "moment"; // Make sure moment.js is installed
import { ShimmerDialogEditProduct } from "components/app/shrimmer/Shrimmer";
import { Textarea } from "components/ui/textarea";
import UsedEndMonthDay from "pages/business-suite/UsedEndMonthDay";
import DailogAddApprovers from "./DailogAddApprovers";
import DailogAddRemark from "./DailogAddRemark";
import DailogAddWorkflow from "./DailogAddWorkflow";

import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from "components/ui/select";
import appStore from "store/appStore";

export default function PageLeavRequest({
  setOpenPopoverIndex,
  employeeInitRequest,
  loadingSubmitEmployeeInitRequest,
  setFormData,
  formData,
  handleSave,
  handleSave2,
  handleSave3,
  handleSave4,
  setEmployeeInitRequest,
  loadingEmployeeInitRequestSearchDatail,
  getShopEmployeeRequestCommittee,
  shopEmployeeRequestCommittee,
  handleAddApprover,
  handleScrollCommittee,
  scrollContainerRef,
  warning,
  errorStatus,
  fetchMoreDataCommittee,
  setShopEmployeeRequestCommittee,
  isAddApproverLoading,
  submitShopEmployeeRequestUpdateStatus,
  submitShopEmployeeRequestUpdateStatusLoading,
  formData2,
  setFormData2,
  formData3,
  setFormData3,
  formData4,
  setFormData4,
  warning2,
}: any) {
  const [selectedCodes, setSelectedCodes] = useState<string>(""); //
  const { showDialogConfirm } = appStore();
  const [valuesRemark1, setValuesRemark1] = useState("");
  const [valuesRemark2, setValuesRemark2] = useState("");
  const [valuesRemark3, setValuesRemark3] = useState("");
  const [valuesRemark4, setValuesRemark4] = useState("");
  const [valuesWhyMissing, setValuesWhyMissing] = useState("");
  useEffect(() => {
    if (employeeInitRequest?.document) {
      setFormData((prev: any) => ({
        ...prev,
        starting_date: employeeInitRequest?.document.starting_date || "",
        ending_date: employeeInitRequest?.document.ending_date || "",
        no_of_day: employeeInitRequest?.document.no_of_day || "",
        leave_period: employeeInitRequest?.document.leave_period || "",
        leave_type: employeeInitRequest?.document.leave_type || "",
        starting_time: employeeInitRequest?.document.starting_time || "",
        ending_time: employeeInitRequest?.document.ending_time || "",
        reason: employeeInitRequest?.document.reason || valuesRemark1,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employeeInitRequest]);
  useEffect(() => {
    if (employeeInitRequest?.document) {
      const periodString = employeeInitRequest.document.missing_period || "";
      const defaultSelected = periodString
        .split("|")
        .map((item: any) => item.trim())
        .filter(Boolean)
        .join(" | "); // ✅ Join back to string
      setSelectedCodes(defaultSelected); // ✅ now it's a string, no error
      setFormData2((prev: any) => ({
        ...prev,
        working_date: employeeInitRequest.document.working_date || "",
        missing_period: periodString,
        missing_type: employeeInitRequest.document.missing_type || valuesWhyMissing,
        missing_remark: employeeInitRequest.document.missing_remark || valuesRemark2,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employeeInitRequest]);
  useEffect(() => {
    if (employeeInitRequest?.document) {
      setFormData3((prev: any) => ({
        ...prev,
        working_date: employeeInitRequest.document.working_date || "",
        remark: employeeInitRequest.document.remark || valuesRemark3,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employeeInitRequest]);

  useEffect(() => {
    if (employeeInitRequest?.document) {
      setFormData4((prev: any) => ({
        ...prev,
        to_shift_group_id: employeeInitRequest.document?.to_shift_group?.shift_group_id ?? "",
        working_date: employeeInitRequest.document.working_date || "",
        remark: employeeInitRequest.document.remark || valuesRemark4,
        to_shift_group: employeeInitRequest.document?.to_shift_group || "",
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employeeInitRequest]);

  const handleChange = (field: string, value: any) => {
    setFormData((prev: any) => ({
      ...prev,
      [field]: value,
    }));
  };
  const handleChange2 = (field: string, value: any) => {
    setFormData2((prev: any) => ({
      ...prev,
      [field]: value,
    }));
  };
  const handleChange3 = (field: string, value: any) => {
    setFormData3((prev: any) => ({
      ...prev,
      [field]: value,
    }));
  };
  const handleChange4 = (field: string, value: any) => {
    setFormData4((prev: any) => ({
      ...prev,
      [field]: value,
    }));
  };

  useEffect(() => {
    if (formData.starting_date && formData.no_of_day) {
      const endingDate = moment(formData.starting_date)
        .add(formData.no_of_day - 1, "days")
        .format("YYYY-MM-DD");
      setFormData((prev: any) => ({
        ...prev,
        ending_date: endingDate,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.starting_date, formData.no_of_day]);

  const [entitlements, setEntitlements] = useState<any[]>([]);
  const monthDate = moment(formData.starting_date).format("yyyy"); // or "YYYY"

  useEffect(() => {
    const monthDate = moment(formData.starting_date).format("yyyy"); // or "YYYY"

    const dataToFilter = Array.isArray(employeeInitRequest?.document?.entitlements) ? employeeInitRequest.document.entitlements : [];

    const result = dataToFilter.filter((item: any) => item.entitlement_year?.toString().includes(monthDate));

    setEntitlements(result);
  }, [formData.starting_date, employeeInitRequest]);
  const [isRemovingApprover, setIsRemovingApprover] = useState<boolean>(false);

  const [isOpenDialogApporver, setIsOpenDialogApporver] = useState<boolean>(false);
  const [isOpenDialogWorkflow, setIsOpenDialogWorkflow] = useState<boolean>(false);
  const [isDailogAddRemark, setisDailogAddRemark] = useState<boolean>(false);
  const [status, setStatus] = useState<any>("");
  const handleClick = (code: string) => {
    const parts = selectedCodes ? selectedCodes.split("|").map((s) => s.trim()) : [];
    const updatedParts = parts.includes(code) ? parts.filter((item) => item !== code) : [...parts, code];
    const updatedString = updatedParts.join("|");
    setSelectedCodes(updatedString);
    setFormData2((prevData: any) => ({
      ...prevData,
      missing_period: updatedString,
    }));
  };
  const handleCloseDetail = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete("request_id");
    window.history.pushState({}, "", url.toString());
    setOpenPopoverIndex(null);
    // setIsDetail(false);
  };
  return (
    <div className="custom-dialog-class flex flex-col justify-between  h-[calc(100vh-80px)]">
      {/* Header */}
      <div>
        <div className="flex items-center justify-between">
          <div className="flex flex-col gap-2 absolute left-3 top-[12px]">
            <div className="text-lg font-bold">{employeeInitRequest?.request_type}</div>
            <div>
              {employeeInitRequest?.request_type === "Leave Application Form" && "Please fill out the details of your leave request."}
              {employeeInitRequest?.request_type === "Tardinees Application Form" && "Fill out this form to document your late attendance."}
              {employeeInitRequest?.request_type === "Change DO Application Form" && "Submit your request to modify your regular day off schedule."}
              {employeeInitRequest?.request_type === "Change Shift Application Form" && "Request to modify assigned work shift schedule."}
            </div>
          </div>
          {employeeInitRequest && (
            <div
              className={`absolute flex items-center py-1 text-white px-5 justify-center font-bold  ${
                employeeInitRequest?.status === "Pending"
                  ? "bg-yellow-500"
                  : employeeInitRequest?.status === "Draft"
                  ? "bg-gray-500"
                  : employeeInitRequest?.status === "Approved"
                  ? "bg-green-500"
                  : "bg-red-500"
              }  rounded-md right-[60px] top-[16px] z-40    `}
            >
              {employeeInitRequest?.status}
            </div>
          )}

          <div
            className="absolute flex items-center justify-center right-3 top-[12px] z-40 cursor-pointer rounded-full bg-accent hover:text-accent-foreground w-10 h-10 border border-gray-300"
            onClick={() => handleCloseDetail()}
          >
            <X />
          </div>
        </div>
      </div>
      {warning ? (
        <div className="flex flex-col gap-2 items-center justify-center h-full w-full">
          <CircleAlert className="text-yellow-500 mx-auto w-[200px] h-[200px]" />
          <h1
            className={`text-[30px] font-semibold   ${
              errorStatus?.title === "success" || errorStatus?.title === "info" ? "text-green-500" : errorStatus?.title === "warning" ? "text-yellow-500" : "text-red-500"
            }`}
          >
            {errorStatus?.title === "success" ? "success" : errorStatus?.title === "info" ? "Infomation" : errorStatus?.title === "warning" ? "Warning" : "Error"}
          </h1>
          <span className=" text-muted-foreground text-md pt-3 ">{errorStatus?.message}</span>
        </div>
      ) : (
        <>
          {warning2 ? (
            <div className="flex flex-col gap-2 items-center justify-center h-full w-full">
              <CircleAlert className="text-yellow-500 mx-auto w-[200px] h-[200px]" />
              <h1
                className={`text-[30px] font-semibold   ${
                  errorStatus?.title === "success" || errorStatus?.title === "info" ? "text-green-500" : errorStatus?.title === "warning" ? "text-yellow-500" : "text-red-500"
                }`}
              >
                {errorStatus?.title === "success" ? "success" : errorStatus?.title === "info" ? "Infomation" : errorStatus?.title === "warning" ? "Warning" : "Error"}
              </h1>
              <span className=" text-muted-foreground text-md pt-3 ">{errorStatus?.message}</span>
            </div>
          ) : (
            <>
              {loadingEmployeeInitRequestSearchDatail ? (
                <div className="h-[80vh] mt-8 overflow-hidden">
                  <ShimmerDialogEditProduct />
                </div>
              ) : (
                <ScrollArea className="mt-8 gap-3 pr-[10px] pb-[50px] h-full">
                  <div className="space-y-6 px-1 py-1">
                    {/* ------requester----- */}
                    <div>
                      <h4 className="text-xl font-semibold text-blue-600">Requester</h4>
                      <table className="min-w-full border-collapse  overflow-hidden mt-2 rounded-md">
                        <thead className="sticky top-0   ">
                          <tr className="">
                            <th className=" w-[100px] "></th>
                            <th className="  w-[100px] "></th>
                            <th className=" w-[100px] "></th>
                            <th className="w-[100px]"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr className={`group text-center  bg-gray-200 dark:bg-[#2c3a52] `}>
                            <td className=" h-[100px] p-0 m-0">
                              <img
                                className={`z-1 w-[100px] h-full rounded-tl-md rounded-bl-md  `}
                                src={!employeeInitRequest?.requester?.picture ? noneProfile : employeeInitRequest?.requester?.picture}
                                alt={employeeInitRequest?.request?.picture}
                              />
                            </td>
                            <td className="py-2 px-4 text-md  text-left align-top  w-[200px]">
                              <p className="text-[15px] font-bold "> {employeeInitRequest?.requester?.local_name}</p>
                              <p className="text-md text-muted-foreground "> {employeeInitRequest?.requester?.english_name}</p>
                              <p className="text-md text-muted-foreground ">{employeeInitRequest?.requester?.nationality}</p>
                            </td>
                            <td className="py-2 px-4  text-md  text-left align-top text-nowrap  w-[200px]">
                              <p className="text-md "> {employeeInitRequest?.requester?.gender}</p>
                              <p className="text-md text-muted-foreground"> {employeeInitRequest?.requester?.marital_status}</p>
                              <p className="text-md flex items-center  gap-2  text-muted-foreground text-nowrap">
                                {(() => {
                                  const date = new Date(employeeInitRequest?.requester?.date_of_birth);
                                  const day = date.getDate();
                                  const weekday = date.toLocaleDateString("en-GB", {
                                    weekday: "short",
                                  });
                                  const month = date.toLocaleDateString("en-GB", {
                                    month: "short",
                                  });

                                  const year = date.getFullYear();
                                  return `${weekday}, ${day}-${month}-${year}`;
                                })()}
                              </p>
                            </td>
                            <td className="py-2 px-4   text-md  text-left align-top  w-[200px]">
                              <p className="text-md "> {employeeInitRequest?.requester?.phone_no}</p>
                              <p className="text-md line-clamp-1 text-muted-foreground"> {employeeInitRequest?.requester?.email}</p>
                              <p className="text-md text-muted-foreground">{employeeInitRequest?.requester?.address}</p>
                            </td>

                            <td className="py-2 px-4  text-md  text-left align-top  w-[200px]">
                              <p className="text-md line-clamp-1 "> {employeeInitRequest?.requester?.department}</p>
                              <p className="text-md text-muted-foreground "> {employeeInitRequest?.requester?.position}</p>
                              <div className="flex items-center gap-1 text-muted-foreground">
                                <p className="text-md text-nowrap"> {Service.formatTime(employeeInitRequest?.requester?.timesheet?.starting_time)}</p>
                                {employeeInitRequest?.requester?.timesheet?.starting_time && employeeInitRequest?.requester?.timesheet?.ending_time && "-"}
                                <p className="text-md text-nowrap "> {Service.formatTime(employeeInitRequest?.requester?.timesheet?.ending_time)}</p>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    {/* -----------Leave Application Form------- */}
                    {employeeInitRequest?.request_type === "Leave Application Form" && (
                      <>
                        {/* Entitlements */}

                        <div>
                          <h4 className="text-xl font-semibold text-blue-600">Entitlements</h4>

                          <table className="min-w-full border-collapse  rounded-md overflow-hidden mt-2">
                            <thead className="sticky top-0 left-0 text-xs text-gray-700  bg-gray-300 dark:bg-[#2c3a52] dark:text-gray-400">
                              <tr className="border-none text-[15px] text-start  ">
                                <th className="px-4 py-3 text-start">{monthDate}</th>
                                <th className="px-4 py-3 text-end">Jan</th>
                                <th className="px-4 py-3 text-end">Feb</th>
                                <th className="px-4 py-3 text-end">Mar</th>
                                <th className="px-4 py-3 text-end">Apr</th>
                                <th className="px-4 py-3 text-end">May</th>
                                <th className="px-4 py-3 text-end">Jun</th>
                                <th className="px-4 py-3 text-end">Jul</th>
                                <th className="px-4 py-3 text-end">Aug</th>
                                <th className="px-4 py-3 text-end">Sep</th>
                                <th className="px-4 py-3 text-end">Oct</th>
                                <th className="px-4 py-3 text-end">Nov</th>
                                <th className="px-4 py-3 text-end">Dec</th>
                              </tr>
                            </thead>
                            <tbody>
                              {entitlements?.map((item: any, index: number) => {
                                return (
                                  <tr
                                    key={index}
                                    className={`text-center group  ${index % 2 === 0 ? "bg-gray-100 dark:bg-[#1e293b] " : "bg-gray-200 dark:bg-[#2c3a52] "} hover:bg-gray-300`}
                                  >
                                    <UsedEndMonthDay item={item} />
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                        {/* Leave Type */}
                        <div>
                          <h4 className="text-xl font-semibold text-blue-600">Leave Type</h4>
                          <div className="grid lg:grid-cols-6 md:grid-cols-4 grid-cols-3 gap-2 mt-2">
                            {[
                              "Annual Leave",
                              "Prolong illness Leave",
                              "Compassinonate Leave",
                              "Block Leave",
                              "Unpaid Leave",
                              "Sick Leave",
                              "Special Leave",
                              "Marriage leave",
                              "Paternlty Leave",
                              "Change Day-Off Leave",
                            ].map((leave_type, index) => (
                              <button
                                disabled={employeeInitRequest?.status === "Pending" || employeeInitRequest?.status === "Approved"}
                                key={index}
                                onClick={() => handleChange("leave_type", leave_type)}
                                className={`border outline-none px-4  py-1.5 rounded-lg text-sm font-semibold ${
                                  formData.leave_type === leave_type ? "bg-blue-500 text-white" : ""
                                }`}
                              >
                                <p className="text-md font-semibold line-clamp-2 overflow-hidden">{leave_type}</p>
                              </button>
                            ))}
                          </div>
                        </div>

                        {/* Leave Detail */}
                        <div className="">
                          <h4 className="text-xl font-semibold text-blue-600">Leave Detail</h4>

                          {/* Day Type Selection */}
                          <div className="grid grid-cols-6 gap-2 mb-4 mt-2">
                            {["Full Day", "During Working Hour"].map((type) => (
                              <button
                                disabled={employeeInitRequest?.status === "Pending" || employeeInitRequest?.status === "Approved"}
                                key={type}
                                onClick={() => handleChange("leave_period", type)}
                                className={`border px-4 py-1.5 rounded-lg text-sm font-semibold ${formData.leave_period === type ? "bg-blue-500 text-white" : ""}`}
                              >
                                <p className="text-md font-semibold line-clamp-2 overflow-hidden">{type}</p>
                              </button>
                            ))}
                          </div>

                          {/* Conditional Inputs */}
                          <div className="grid grid-cols-6 gap-4 mb-4 mt-2">
                            {formData.leave_period === "Full Day" ? (
                              <>
                                <div>
                                  <label>From</label>
                                  <DatePicker
                                    disabled={employeeInitRequest?.status === "Pending" || employeeInitRequest?.status === "Approved"}
                                    className="py-3 h-[45px] text-[15px] border border-gray-300 mt-2"
                                    value={formData.starting_date}
                                    onChange={(e) => handleChange("starting_date", e)}
                                  />
                                </div>
                                <div>
                                  <label>No. Of Day</label>
                                  <NumberInput
                                    disabled={employeeInitRequest?.status === "Pending" || employeeInitRequest?.status === "Approved"}
                                    className="py-[22px] text-[17px]  mt-2"
                                    value={formData.no_of_day}
                                    onChange={(e) => handleChange("no_of_day", Number(e.target.value))}
                                  />
                                </div>
                                <div>
                                  <label>To</label>
                                  <DatePicker
                                    disabled={employeeInitRequest?.status === "Pending" || employeeInitRequest?.status === "Approved"}
                                    className="py-3 h-[45px] text-[17px] border border-gray-300  mt-2"
                                    value={formData.ending_date}
                                    onChange={(e) => handleChange("toDate", e)}
                                  />
                                </div>
                              </>
                            ) : (
                              <>
                                <div>
                                  <label>Working Date</label>
                                  <DatePicker
                                    disabled={employeeInitRequest?.status === "Pending" || employeeInitRequest?.status === "Approved"}
                                    className="py-3 h-[45px] text-[17px] border border-gray-300  mt-2"
                                    value={formData.starting_date}
                                    onChange={(e) => handleChange("starting_date", e)}
                                  />
                                </div>
                                <div>
                                  <label>From Time</label>
                                  <TimePicker
                                    disabled={employeeInitRequest?.status === "Pending" || employeeInitRequest?.status === "Approved"}
                                    className=" mt-2"
                                    value={formData.starting_time}
                                    onChange={(value) => handleChange("starting_time", value)}
                                  />
                                </div>
                                <div>
                                  <label>To Time</label>
                                  <TimePicker
                                    disabled={employeeInitRequest?.status === "Pending" || employeeInitRequest?.status === "Approved"}
                                    className=" mt-2"
                                    value={formData.ending_time}
                                    onChange={(value) => handleChange("ending_time", value)}
                                  />
                                </div>
                              </>
                            )}
                          </div>
                          <div>
                            <label> Reason</label>
                            <Textarea
                              disabled={employeeInitRequest?.status === "Pending" || employeeInitRequest?.status === "Approved"}
                              className="text-[15px] focus:border-none focus:border-1 mt-2"
                              value={formData.reason}
                              onChange={(e) => {
                                handleChange("reason", e.target.value);
                                setValuesRemark1(e.target.value);
                              }}
                              rows={4}
                            />
                          </div>
                        </div>
                      </>
                    )}
                    {/* -----------Tardiness Application Form------- */}

                    {employeeInitRequest?.request_type === "Tardiness Application Form" && (
                      <>
                        <div>
                          <h4 className="text-xl font-semibold text-blue-600 mb-2">Tardiness Detail</h4>
                          <div>
                            <label>Working Date</label>
                            <div className="grid  grid-cols-5 gap-2 mt-2">
                              <DatePicker
                                disabled={employeeInitRequest?.status === "Pending" || employeeInitRequest?.status === "Approved"}
                                className="py-3 h-[45px] text-[15px] border border-gray-300"
                                value={formData2.working_date}
                                onChange={(e) => handleChange2("working_date", e)}
                              />
                            </div>
                          </div>
                        </div>

                        <div>
                          <h4 className="text-xl font-semibold text-blue-600">Why Missing</h4>
                          <div className="grid lg:grid-cols-6 md:grid-cols-4 grid-cols-3 gap-2 mt-2">
                            {[
                              "Missing to swipe in or out for the assinged",
                              "Attendance Training",
                              "Failing to bring the employee ID card to work",
                              "Forgot to swipe in or out",
                              "Attendance machine is not working",
                              "Other",
                            ].map((missing_type, index) => (
                              <button
                                disabled={employeeInitRequest?.status === "Pending" || employeeInitRequest?.status === "Approved"}
                                key={index}
                                onClick={() => {
                                  handleChange2("missing_type", missing_type);
                                  setValuesWhyMissing(missing_type);
                                }}
                                className={`border outline-none px-4  py-1.5 rounded-lg text-sm font-semibold ${
                                  formData2.missing_type === missing_type ? "bg-primary text-white" : ""
                                }`}
                              >
                                <p className="text-md font-semibold line-clamp-2 overflow-hidden ">{missing_type}</p>
                              </button>
                            ))}
                          </div>
                        </div>
                        {formData2.missing_type === "Other" && (
                          <div>
                            <label> Other Reason</label>
                            <Textarea
                              disabled={employeeInitRequest?.status === "Pending" || employeeInitRequest?.status === "Approved"}
                              className="text-[15px] focus:border-none focus:border-1 mt-2"
                              value={formData2.missing_remark}
                              onChange={(e) => {
                                handleChange2("missing_remark", e.target.value);
                                setValuesRemark2(e.target.value);
                              }}
                              rows={4}
                            />
                          </div>
                        )}

                        <div>
                          <h4 className="text-xl font-semibold text-blue-600">Missing Time </h4>
                          <div className="grid lg:grid-cols-6 md:grid-cols-4 grid-cols-3 gap-2 mt-2">
                            {["Time In", "Break Out", "Break In", "Time Out"].map((missing_period, index) => (
                              <button
                                disabled={employeeInitRequest?.status === "Pending" || employeeInitRequest?.status === "Approved"}
                                key={index}
                                onClick={() => handleClick(missing_period)}
                                className={`border outline-none px-4  py-1.5 rounded-lg text-sm font-semibold ${
                                  selectedCodes.includes(missing_period) ? "bg-primary text-white border-transparent " : "dark:bg-transparent "
                                }}`}
                              >
                                <p className="text-md font-semibold line-clamp-2 overflow-hidden">{missing_period}</p>
                              </button>
                            ))}
                          </div>
                        </div>
                      </>
                    )}
                    {/* -----------Change DO Application Form------- */}

                    {employeeInitRequest?.request_type === "Change DO Application Form" && (
                      <>
                        <div>
                          <h4 className="text-xl font-semibold text-blue-600 mb-2">Change Day Off Detail</h4>
                          <div>
                            <label>Working Date (OFF)</label>
                            <div className="grid  grid-cols-5 gap-2 mt-2">
                              <DatePicker
                                disabled={employeeInitRequest?.status === "Pending" || employeeInitRequest?.status === "Approved"}
                                className="py-3 h-[45px] text-[15px] border border-gray-300"
                                value={formData3.working_date}
                                onChange={(e) => {
                                  handleChange3("working_date", e);
                                }}
                              />
                            </div>
                          </div>
                        </div>

                        <div>
                          <label> Reason </label>
                          <Textarea
                            disabled={employeeInitRequest?.status === "Pending" || employeeInitRequest?.status === "Approved"}
                            className="text-[15px] focus:border-none focus:border-1 mt-2"
                            value={formData3.remark}
                            onChange={(e) => {
                              handleChange3("remark", e.target.value);
                              setValuesRemark3(e.target.value);
                            }}
                            rows={4}
                          />
                        </div>
                      </>
                    )}
                    {/* -----------Change Shift Application Form------- */}

                    {employeeInitRequest?.request_type === "Change Shift Application Form" && (
                      <>
                        <div>
                          <h4 className="text-xl font-semibold text-blue-600 mb-2"> Change Shift Detail </h4>

                          <div className="grid grid-cols-6 gap-4 mb-4 mt-2">
                            <>
                              <div>
                                <label>Working Date</label>
                                <DatePicker
                                  disabled={employeeInitRequest?.status === "Pending" || employeeInitRequest?.status === "Approved"}
                                  className="py-3 h-[45px] text-[15px] border border-gray-300 "
                                  value={formData4.working_date}
                                  onChange={(e) => handleChange4("working_date", e)}
                                />
                              </div>
                              <div className=" relative overflow-hidden px-3 pb-2">
                                <label className="mb-2">To Shift</label>
                                {/* {isDetail && <label className="mb-2 absolute top-[35px] left-7">{formData4.to_shift_group.local_description}</label>} */}
                                <Select
                                  disabled={employeeInitRequest?.status === "Pending" || employeeInitRequest?.status === "Approved"}
                                  value={formData4.to_shift_group_id} // ✅ Use shift_group_id as the value
                                  onValueChange={(val: any | number) => {
                                    setFormData4((prev: any) => ({
                                      ...prev,
                                      to_shift_group_id: val,
                                    }));
                                  }}
                                >
                                  <SelectTrigger className=" py-[22px] text-[15px]  ">
                                    <SelectValue className="" />
                                  </SelectTrigger>
                                  <SelectContent className="text-[15px]">
                                    <SelectGroup>
                                      {employeeInitRequest?.document?.shift_groups?.map((item: any) => (
                                        <SelectItem key={item.shift_group_id} value={item.shift_group_id}>
                                          {item.local_description}
                                        </SelectItem>
                                      ))}
                                    </SelectGroup>
                                  </SelectContent>
                                </Select>
                              </div>
                            </>
                          </div>
                        </div>

                        <div>
                          <label> Reason </label>
                          <Textarea
                            disabled={employeeInitRequest?.status === "Pending" || employeeInitRequest?.status === "Approved"}
                            className="text-[15px] focus:border-none focus:border-1 mt-2"
                            value={formData4.remark}
                            onChange={(e) => {
                              handleChange4("remark", e.target.value);
                              setValuesRemark4(e.target.value);
                            }}
                            rows={4}
                          />
                        </div>
                      </>
                    )}
                    <div>
                      <h4 className="text-xl font-semibold text-blue-600">Approvers</h4>
                      <div className={`grid md:grid-cols-3 ${window.innerWidth <= 1500 ? "lg:grid-cols-5" : "lg:grid-cols-5"}  gap-y-3 gap-x-2 mb-10 mt-2 `}>
                        {employeeInitRequest?.approvers?.map((item: any, index: number) => {
                          return (
                            <>
                              <div key={index} className={`relative z-1 w-full max-w-sm border rounded-lg h-[370px] `}>
                                <div className=" w-full relative overflow-hidden  ">
                                  <ImageUrl className="rounded-t-md  w-full h-full " src={!item.accept_employee?.picture ? noneProfile : item.accept_employee?.picture} alt="" />
                                </div>
                                <label className="absolute opacity-80 p-1 mx-auto z-50 top-2 right-2 text-white group bg-red-500  font-semibold  rounded-full                                                                                                  w-8 h-8 flex items-center justify-center text-md  ">
                                  {isRemovingApprover ? (
                                    <Loader className="animate-spin" />
                                  ) : (
                                    <Minus
                                      onClick={async () => {
                                        if (employeeInitRequest?.status === "Pending" || employeeInitRequest?.status === "Approved") {
                                          return;
                                        }
                                        setIsRemovingApprover(true);
                                        await new Promise((resolve) => setTimeout(resolve, 500)); // simulate API delay
                                        setEmployeeInitRequest((prev: any) => ({
                                          ...prev,
                                          approvers: (prev.approvers || []).filter((approver: any) => approver.accept_employee?.id !== item.accept_employee?.id),
                                        }));
                                        setIsRemovingApprover(false);
                                      }}
                                      className={`w-8 h-8  ${
                                        employeeInitRequest?.status === "Pending" || (employeeInitRequest?.status === "Approved" ? " cursor-not-allowed" : " cursor-pointer")
                                      }`}
                                    />
                                  )}
                                </label>
                                <div className={`p-4 `}>
                                  <h5 className="text-md font-semibold line-clamp-2 overflow-hidden h-[20px] ">{item?.accept_employee?.local_name}</h5>
                                  <span className="text-sm line-clamp-1 overflow-hidden h-[20px]  ">{item?.accept_employee?.department}</span>

                                  <p className=" font-semibold line-clamp-2 text-sm text-muted-foreground h-[20px]"> {item.accept_employee?.position}</p>

                                  <p className="font-semibold line-clamp-2 text-sm  text-muted-foreground h-[20px]">
                                    {(() => {
                                      const date = new Date(item.accept_employee?.joined_date);
                                      const day = date.getDate();
                                      const weekday = date.toLocaleDateString("en-GB", {
                                        weekday: "short",
                                      });
                                      const month = date.toLocaleDateString("en-GB", {
                                        month: "short",
                                      });

                                      const year = date.getFullYear();
                                      return `${month}, ${day}-${weekday}-${year}`;
                                    })()}
                                  </p>
                                </div>
                              </div>
                            </>
                          );
                        })}
                        {employeeInitRequest?.approvers?.length === 0 && (
                          <div
                            onClick={() => {
                              if (employeeInitRequest?.status === "Pending" || employeeInitRequest?.status === "Approved") {
                                return;
                              }
                              setIsOpenDialogApporver(true);
                            }}
                            className={`${
                              employeeInitRequest?.status === "Pending" || employeeInitRequest?.status === "Approved" ? "" : "cursor-pointer"
                            } h-[370px] flex items-center justify-center w-full max-w-sm rounded-lg  border border-gray-200 bg-gray-100 dark:bg-black`}
                          >
                            <label className="p-1 mx-auto z-50 top-2 right-2 text-white group bg-blue-500 font-semibold  rounded-full w-8 h-8 flex items-center justify-center text-md">
                              <Plus
                                className={`${
                                  employeeInitRequest?.status === "Pending" || employeeInitRequest?.status === "Approved" ? "" : "cursor-pointer"
                                } text-sm  dark:text-white`}
                              />
                            </label>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <ScrollBar orientation="vertical" />
                </ScrollArea>
              )}
              {/* Save Button */}
              <div className="flex justify-between gap-3 pr-[20px] items-center px-4 left-0 w-full">
                {employeeInitRequest?.status === "Pending" &&
                  (employeeInitRequest?.allow_cancel === "Yes" ? (
                    <>
                      <button
                        onClick={() => {
                          setisDailogAddRemark(true);
                          setStatus("Cancelled");
                        }}
                        className="w-full outline-none focus:border-none mt-6 flex items-center justify-center bg-red-500 text-white text-lg py-2 rounded-lg"
                      >
                        Cancel
                      </button>
                    </>
                  ) : employeeInitRequest?.allow_accept === "Yes" ? (
                    <>
                      <button
                        onClick={() => {
                          setisDailogAddRemark(true);
                          setStatus("Rejected");
                        }}
                        className="w-full outline-none focus:border-none mt-6 flex items-center justify-center bg-red-500 text-white text-lg py-2 rounded-lg"
                      >
                        Reject
                      </button>
                      <button
                        onClick={() => {
                          setisDailogAddRemark(true);
                          setStatus("Approved");
                        }}
                        className="w-full outline-none focus:border-none mt-6 flex items-center justify-center bg-green-500 text-white text-lg py-2 rounded-lg"
                      >
                        Approve
                      </button>
                    </>
                  ) : null)}

                {employeeInitRequest?.status === "Cancelled" && employeeInitRequest?.allow_cancel === "Yes" && (
                  <>
                    <button
                      onClick={() =>
                        showDialogConfirm({
                          titileButtonSubmit: "Yes, Delete",
                          titileButtonCancel: "No, Cancel",
                          title: "Delete",
                          message: "Do you want to delete ?",
                          onSubmit() {
                            submitShopEmployeeRequestUpdateStatus(employeeInitRequest?.id, "Deleted", "");
                            setOpenPopoverIndex(null);
                          },
                        })
                      }
                      className="w-full outline-none focus:border-none mt-6 flex items-center justify-center bg-red-500 text-white text-lg py-2 rounded-lg"
                    >
                      Delete
                    </button>
                    <button
                      onClick={() => {
                        if (employeeInitRequest?.request_type === "Leave Application Form") {
                          handleSave("");
                        } else if (employeeInitRequest?.request_type === "Tardiness Application Form") {
                          handleSave2("");
                        } else if (employeeInitRequest?.request_type === "Change Shift Application Form") {
                          handleSave4("");
                        } else {
                          handleSave3("");
                        }
                      }}
                      className="w-full outline-none focus:border-none mt-6 flex items-center justify-center bg-blue-500 text-white text-lg py-2 rounded-lg"
                    >
                      {loadingSubmitEmployeeInitRequest ? <Loader className="animate-spin" /> : "Resubmit"}
                    </button>
                  </>
                )}

                {employeeInitRequest?.status === "Approved" && employeeInitRequest?.allow_cancel === "Yes" && (
                  <button
                    onClick={() => {
                      setisDailogAddRemark(true);
                      setStatus("Cancelled");
                    }}
                    className="w-full  outline-none focus:border-none mt-6 flex items-center justify-center bg-red-500 text-white text-lg py-2 rounded-lg"
                  >
                    Cancel
                  </button>
                )}

                {employeeInitRequest?.status === "Draft" && (
                  <button
                    onClick={() => {
                      if (employeeInitRequest?.request_type === "Leave Application Form") {
                        handleSave("");
                      } else if (employeeInitRequest?.request_type === "Tardiness Application Form") {
                        handleSave2("");
                      } else if (employeeInitRequest?.request_type === "Change Shift Application Form") {
                        handleSave4("");
                      } else {
                        handleSave3("");
                      }
                    }}
                    className={`w-full outline_none focus:border-none mt-6 flex items-center justify-center ${
                      employeeInitRequest?.approvers.length !== 0 ? "bg-blue-500" : "bg-green-500"
                    } bg-blue-500 text-white text-lg py-2 rounded-lg`}
                  >
                    {loadingSubmitEmployeeInitRequest ? <Loader className="animate-spin" /> : employeeInitRequest?.approvers.length !== 0 ? "Submit" : "Release"}
                  </button>
                )}
              </div>
            </>
          )}
        </>
      )}
      <DailogAddRemark
        submitShopEmployeeRequestUpdateStatus={submitShopEmployeeRequestUpdateStatus}
        setOpenPopoverIndex={setOpenPopoverIndex}
        employeeInitRequest={employeeInitRequest}
        isDailogAddRemark={isDailogAddRemark}
        setisDailogAddRemark={setisDailogAddRemark}
        status={status}
        submitShopEmployeeRequestUpdateStatusLoading={submitShopEmployeeRequestUpdateStatusLoading}
      />

      <DailogAddApprovers
        scrollContainerRef={scrollContainerRef}
        isOpenDialogApporver={isOpenDialogApporver}
        setIsOpenDialogApporver={setIsOpenDialogApporver}
        shopEmployeeRequestCommittee={shopEmployeeRequestCommittee}
        handleAddApprover={handleAddApprover}
        handleScrollCommittee={handleScrollCommittee}
        fetchMoreDataCommittee={fetchMoreDataCommittee}
        getShopEmployeeRequestCommittee={getShopEmployeeRequestCommittee}
        isAddApproverLoading={isAddApproverLoading}
        setShopEmployeeRequestCommittee={setShopEmployeeRequestCommittee}
        employeeInitRequest={employeeInitRequest}
      />
      <DailogAddWorkflow isOpenDialogWorkflow={isOpenDialogWorkflow} setIsOpenDialogWorkflow={setIsOpenDialogWorkflow} />
    </div>
  );
}
